/*global config: false */
module.exports = config;
